import { isProd } from './isProd'

// category - address, hash
export const generateStrkScanUrl = (category, value) => {
  const baseUrl = isProd
    ? 'https://voyager.online'
    : 'https://sepolia.voyager.online'

  if (category === 'contract') {
    return `${baseUrl}/contract/${value}`
  } else if (category === 'transaction') {
    return `${baseUrl}/tx/${value}`
  }

  return null
}
